import React from 'react';
import styles from '../AnalysisConfig.module.css';

interface ConfigHeaderProps {
  methodIcon: string;
  methodTitle: string;
  minConfidence: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export const ConfigHeader: React.FC<ConfigHeaderProps> = ({
  methodIcon,
  methodTitle,
  minConfidence,
  isExpanded,
  onToggle
}) => {
  return (
    <button className={styles.configToggle} onClick={onToggle}>
      <div className={styles.configSummary}>
        <i className="pi pi-cog" />
        <span>Analysis Configuration</span>
        <div className={styles.quickInfo}>
          <i className={`pi ${methodIcon}`} />
          <span>{methodTitle}</span>
          <span className={styles.separator}>•</span>
          <span>{Math.round(minConfidence * 100)}% confidence</span>
        </div>
      </div>
      <i className={`pi ${isExpanded ? 'pi-chevron-up' : 'pi-chevron-down'}`} />
    </button>
  );
};
